import { render, staticRenderFns } from "./editUser.vue?vue&type=template&id=dafa1be8&scoped=true&"
import script from "./editUser.js?vue&type=script&lang=js&"
export * from "./editUser.js?vue&type=script&lang=js&"
import style0 from "./editUser.scss?vue&type=style&index=0&id=dafa1be8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dafa1be8",
  null
  
)

export default component.exports